import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CalendarClock, RefreshCw, AlertCircle } from "lucide-react";
import { fmtCompetencia } from "@/lib/api";
import { BoletoRow } from "./BoletoRow";

/**
 * Painel de listagem de boletos por competência.
 * Recebe ações e delega ao parent.
 */
export function BoletosPanel({
  competencia, boletos, onSincronizarVencimentos, onAutoRegenerarPix, onAplicarEncargos,
  onMarcarPago, onEditarVenc, onRegenerarPix, onAjuste, onIsentarJuros, onImprimir, onCobranca, onExcluir,
}) {
  return (
    <Card className="p-6 rounded-sm border-border">
      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <div>
          <h2 className="font-heading font-bold text-xl">Boletos {fmtCompetencia(competencia)}</h2>
          <p className="text-xs text-muted-foreground mt-1">
            Multa & mora recalculadas automaticamente todo dia às <b>03h UTC</b> nos boletos vencidos.
          </p>
        </div>
        <div className="flex gap-2 flex-wrap">
          <Button data-testid="btn-sincronizar-vencimentos" variant="outline" onClick={onSincronizarVencimentos}
            className="rounded-sm border-info/40 text-info hover:bg-info/5"
            title="Realinha vencimentos dos boletos ABERTOS ao dia_vencimento do contrato">
            <CalendarClock size={14} className="mr-2" /> Sincronizar vencimentos
          </Button>
          <Button data-testid="btn-auto-regenerar-pix" variant="outline" onClick={onAutoRegenerarPix}
            className="rounded-sm border-warning/40 text-warning hover:bg-warning/5"
            title="Consulta o Banco Inter e re-emite Pix para todos os boletos com QR cancelado/expirado">
            <RefreshCw size={14} className="mr-2" /> Regenerar Pix cancelados
          </Button>
          <Button data-testid="btn-aplicar-encargos" variant="outline" onClick={onAplicarEncargos}
            className="rounded-sm border-warning/40 text-warning hover:bg-warning/5">
            <AlertCircle size={14} className="mr-2" /> Aplicar encargos agora
          </Button>
        </div>
      </div>
      {boletos?.length === 0 ? (
        <div className="text-center py-10 text-muted-foreground text-sm border border-dashed rounded-sm">
          Nenhum boleto gerado. Execute o <b>fechamento do mês</b>.
        </div>
      ) : (
        <div className="space-y-2">
          {(boletos || []).map((b) => (
            <BoletoRow key={b.id} b={b}
              onMarcarPago={onMarcarPago} onEditarVenc={onEditarVenc} onRegenerarPix={onRegenerarPix}
              onAjuste={onAjuste} onIsentarJuros={onIsentarJuros} onImprimir={onImprimir}
              onCobranca={onCobranca} onExcluir={onExcluir}
            />
          ))}
        </div>
      )}
    </Card>
  );
}
